import { palette } from '../../styles/tokens';
import type { ScheduleStaffRow } from '../../types';

const HOURS = ['7a', '8a', '9a', '10a', '11a', '12p', '1p', '2p', '3p', '4p', '5p'];
const HOUR_WIDTH = 55;

interface ScheduleMiniProps {
  data: ScheduleStaffRow[];
}

export function ScheduleMini({ data }: ScheduleMiniProps) {
  if (data.length === 0) {
    return (
      <div style={{ padding: '20px 0', textAlign: 'center', color: palette.g400, fontSize: 13.5 }}>
        No shifts scheduled today.
      </div>
    );
  }

  return (
    <div style={{ overflowX: 'auto' }}>
      {/* Hour labels */}
      <div style={{ display: 'flex', marginLeft: 90 }}>
        {HOURS.map(h => (
          <div key={h} style={{
            width: HOUR_WIDTH, flexShrink: 0,
            fontSize: 10.5, fontWeight: 500, color: palette.g400,
            textAlign: 'center', paddingBottom: 6,
          }}>{h}</div>
        ))}
      </div>

      {/* Staff rows */}
      {data.map((person, i) => (
        <div key={i} style={{
          display: 'flex', alignItems: 'center', height: 44,
          borderTop: `1px solid ${palette.g100}`,
        }}>
          {/* Name column */}
          <div style={{ width: 90, flexShrink: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
            <div style={{
              width: 24, height: 24, borderRadius: 12,
              background: person.roleColor,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 9, fontWeight: 600, color: palette.white,
            }}>{person.initials}</div>
            <span style={{ fontSize: 12, fontWeight: 500, color: palette.g700 }}>{person.name}</span>
          </div>

          {/* Time grid */}
          <div style={{ flex: 1, position: 'relative', height: '100%' }}>
            {/* Grid lines */}
            {HOURS.map((_, j) => (
              <div key={j} style={{
                position: 'absolute', left: j * HOUR_WIDTH, top: 0, bottom: 0,
                borderLeft: `1px solid ${palette.g100}`,
              }} />
            ))}

            {/* Shift blocks */}
            {person.blocks.filter(b => b.type === 'shift').map((b, j) => (
              <div key={`s${j}`} style={{
                position: 'absolute',
                left: b.start * HOUR_WIDTH + 1,
                width: (b.end - b.start) * HOUR_WIDTH - 2,
                top: 4, bottom: 4,
                background: `${palette.g100}80`,
                borderRadius: 4,
                border: `1px dashed ${palette.g200}`,
              }} />
            ))}

            {/* Job blocks */}
            {person.blocks.filter(b => b.type === 'job').map((b, j) => (
              <div key={`j${j}`} style={{
                position: 'absolute',
                left: b.start * HOUR_WIDTH + 2,
                width: (b.end - b.start) * HOUR_WIDTH - 4,
                top: 10, bottom: 10,
                background: palette.accent,
                borderRadius: 4,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 10, fontWeight: 500, color: palette.white,
                overflow: 'hidden', whiteSpace: 'nowrap', padding: '0 6px',
                zIndex: 1,
              }}>{b.label}</div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
